module.exports = __webpack_public_path__ + "img/gBalm5.2ca87079.jpg";